const statusObj = {
  ongoing: { name: 'อยู่ระหว่างการผ่อนชำระ', color: '#D35C3B' },
  forgive: { name: 'ยกหนี้ให้', color: '#D35C3B' },
  complete: { name: 'จ่ายครบแล้ว', color: '#228B90' }
}

export {
  statusObj
}
